<terra-dialog-header [showCloseButton]="true">
    <h1 class="large-title">
        Transfer Limits
    </h1>
</terra-dialog-header>

<mat-dialog-content>
    <terra-bank-account-limits 
    [accountLimits]="data.accountLimits" 
    [displayDailyDebit]="data.displayDailyDebit" 
    [displayMonthlyDebit]="data.displayDailyDebit">
    </terra-bank-account-limits>
</mat-dialog-content>

<mat-dialog-actions>
    <button type="button" mat-flat-button color="primary" class="close-button" [mat-dialog-close]="undefined">Close</button>
</mat-dialog-actions>